const initialState = () => ({
  nowSync: new Date(),
  interval: null,
})

export const state = initialState()

export const mutations = {
  UPDATE_TIME_SYNC(state) {
    state.nowSync = new Date()
  },
  SET_TIME_SYNC(state, payload) {
    state.interval = payload
  },
  CLEAR_TIME_SYNC(state) {
    clearTimeout(state.interval)
  },
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
}

export const actions = {
  /**
   * Reset state
   * @param {*} { commit }
   */
  reset({ commit }) {
    commit('CLEAR_TIME_SYNC')
    commit('RESET')
  },
  /**
   * Update every 60 seconds global time sync
   */
  startTimeSync({ commit }) {
    const interval = setInterval(() => {
      commit('UPDATE_TIME_SYNC')
    }, 1000 * 60)

    commit('SET_TIME_SYNC', interval)
  },
  clearTimeSync({ commit }) {
    commit('CLEAR_TIME_SYNC')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
